@if (loading) {
    <div class="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-bg-[var(--sys-loader-bg)]">
        <div class="tw-flex tw-flex-col tw-items-center">
            <mat-spinner diameter="45"></mat-spinner>
            @if (message) {
                <span class="tw-mt-4 tw-font-medium">{{ message | translate }}</span>
            }
        </div>
    </div>
}
